import { render, staticRenderFns } from "./wsTest.vue?vue&type=template&id=0ddd544e&"
import script from "./wsTest.vue?vue&type=script&lang=js&"
export * from "./wsTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports